/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsAdvertisementGtagOptions, FxIdDomainSettingsAdvertisementGtagOptionsFromJSONTyped, FxIdDomainSettingsAdvertisementGtagOptionsToJSON, } from './FxIdDomainSettingsAdvertisementGtagOptions';
export function FxIdDomainSettingsAdvertisementOptionsGtagFromJSON(json) {
    return FxIdDomainSettingsAdvertisementOptionsGtagFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementOptionsGtagFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementGtagOptions(json)) {
        return FxIdDomainSettingsAdvertisementGtagOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsAdvertisementOptionsGtagToJSON(json) {
    return FxIdDomainSettingsAdvertisementOptionsGtagToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementOptionsGtagToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementGtagOptions(value)) {
        return FxIdDomainSettingsAdvertisementGtagOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementOptionsGtag.js.map